import React from "react";
import StatusBadge from "./StatusBadge";

const KycStatusBadge = ({ status }) => (
  <StatusBadge status={status || "NOT_GENERATED"} className="broker-status--kyc" />
);

export default KycStatusBadge;
